<script lang="ts" setup>import { ref as _ref } from 'vue';

import { faSparkles } from '@fortawesome/pro-regular-svg-icons'

withDefaults(defineProps<{
  multiline?: boolean
  aiOptionCallback?: Function | null
  disabled?: boolean
  useWysiwygEditor?: boolean
  onSaveChanges?: ((value: string) => Promise<void>)
  placeholder?: string
  emptyState?: string
  type?: string
}>(), { multiline: false,disabled: false,useWysiwygEditor: false,type: 'text', })

let content = (defineModel<string | null | undefined>({ required: true }))

let isEditing = _ref<boolean>(false)

let newContent = _ref(content.value)
watch(() => isEditing.value, () => { newContent.value = content.value })

const emit = defineEmits<{
  startEditing: []
  finishEditing: []
  cancelClicked: []
}>()

function startEditing () {
  isEditing.value = true
  emit('startEditing')
}

async function onSubmit () {
  await __props.onSaveChanges?.(newContent.value!)
  content.value = newContent.value
  isEditing.value = false
  emit('finishEditing')
}

function cancelEdit () {
  isEditing.value = false
  emit('finishEditing')
  emit('cancelClicked')
}

async function generateTextWithAi () {
  const value = await __props.aiOptionCallback?.()
  if (value) newContent.value = value
}

const Trix = import.meta.env.SSR
  ? 'template'
  : defineAsyncComponent(() => import('@consumer/components/Trix.vue'))
</script>

<template>
  <span v-if="!isEditing">
    <span :class="!content && 'italic'" v-html="content || emptyState || placeholder"/>
    <EditButton
      v-if="!disabled"
      class="ml-1"
      data-testid="edit-icon"
      style="vertical-align: middle;"
      @click="startEditing"
    />
  </span>
  <GForm v-else class="p-4 bg-white rounded-v2lg" :onSubmit="onSubmit" size="small">
    <Trix
      v-if="useWysiwygEditor"
      v-model="newContent"
      :placeholder="placeholder"
      @keydown.escape="cancelEdit"
      @keydown.enter.meta="onSubmit"
    />
    <GTextInput
      v-else
      v-model="newContent"
      v-autofocus
      :multiline="multiline"
      :placeholder="placeholder"
      :type="type"
      @keydown.escape="cancelEdit"
    />
    <div class="mt-3 flex items-center justify-end gap-3">
      <GPromiseButton
        v-if="aiOptionCallback"
        data-testid="ai-button"
        label="Generate Text"
        :icon="faSparkles"
        color="transparent"
        size="small"
        @click="generateTextWithAi"
      />
      <GCancelButton @click="cancelEdit"/>
      <GSaveButton class="w-30"/>
    </div>
  </GForm>
</template>
